<div class="row">
  <div class="col-xs-12">
    <h4>Claim Adjustment Reasons:</h4>
  </div>
</div>
<form
  class="form-horizontal"
  name="claimAdjustmentReasonCodesForm"
  (reset)="resetCarForm()"
  novalidate
>
  <div class="form-group" *ngFor="let item of model.claimAdjustmentReasons; let idx = index">
    <div class="col-xs-4">
      <label for="groupCodes">* Group Code</label>
      <app-select
        id="groupCodes"
        *ngIf="groupCodeOptions.length > 0"
        [items]="groupCodeOptions"
        [allowClear]="true"
        [active]="getActiveGroupCode(item)"
        [disabled]="!canEditClaimAdjustments()"
        [selected]="selectGroupCode(item)"
        [removed]="removeGroupCode(item)"
        placeholder="Select a group code"
      >
      </app-select>
    </div>
    <div class="col-xs-4">
      <label for="carCodes">* Code</label>
      <app-select
        id="carCodes"
        *ngIf="carCodeOptions.length > 0"
        [items]="filteredCarCodeOptions(item)"
        [allowClear]="true"
        [active]="getActiveCarCode(item)"
        [disabled]="!canEditClaimAdjustments()"
        [selected]="selectCarCode(item)"
        [removed]="removeCarCode(item)"
        placeholder="Select a claim adjustment reason code"
      >
      </app-select>
    </div>
    <div class="col-xs-2">
      <label for="amount">* Amount</label>
      <input
        id="amount"
        [name]="'amount' + idx"
        class="form-control"
        type="number"
        [(ngModel)]="item.Amount"
        [disabled]="!canEditClaimAdjustments()"
      />
    </div>
    <div class="col-xs-2">
      <label for="quantity">Quantity</label>
      <input
        id="quantity"
        [name]="'quantity' + idx"
        class="form-control"
        type="number"
        [(ngModel)]="item.Quantity"
        [disabled]="!canEditClaimAdjustments()"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <button
        type="button"
        class="btn btn-primary"
        (click)="saveClaimAdjustmentReasons()"
        [disabled]="!canEditClaimAdjustments() || !carCodesIsValid()"
        [title]="validateClaimAdjustment().join('\r\n')"
      >
        Save
      </button>
      <button type="reset" class="btn btn-default" [disabled]="!canEditClaimAdjustments()">
        Cancel
      </button>
    </div>
  </div>
</form>
